import { Injectable } from '@angular/core';
import { Api } from '../services/api';


@Injectable({
  providedIn: 'root'
})
export class MemberListService {

  constructor(public api: Api) {
  }



  
  getMemberActiveInfo(maMembershipid, status, membershipNbr) {
    let seq = this.api.post('bp/v1/getMembershipInfo', {
      'source': '',
      'maMembershipId': maMembershipid != null ? parseInt(maMembershipid) : null,
      'status': 'A',
      'membershipNbr': membershipNbr != null ? parseInt(membershipNbr) : null
    }, true);
    return seq;
  }

  callAuthService(postData) {
    let seq = this.api.postExternalUrl('https://pfeddev.wal-mart.com/as/token.oauth2', postData);
    return seq;
  }

  errorHandler(error: Response) {
    // return Observable.throw(error);
  }

}
